import { render, staticRenderFns } from "./SendAuthCode.vue?vue&type=template&id=57aa4316&scoped=true&"
import script from "./SendAuthCode.vue?vue&type=script&lang=js&"
export * from "./SendAuthCode.vue?vue&type=script&lang=js&"
import style0 from "./SendAuthCode.vue?vue&type=style&index=0&id=57aa4316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa4316",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57aa4316')) {
      api.createRecord('57aa4316', component.options)
    } else {
      api.reload('57aa4316', component.options)
    }
    module.hot.accept("./SendAuthCode.vue?vue&type=template&id=57aa4316&scoped=true&", function () {
      api.rerender('57aa4316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/pages/signUp/common/SendAuthCode.vue"
export default component.exports